/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Tip_VesselInputs */



/**
* | output |
* | --- |
* | "Vessel name and IMO number" |
*
* @param {Contact_Tip_VesselInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_tip_vessel = /** @type {((inputs?: Contact_Tip_VesselInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Tip_VesselInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船名和 IMO 编号")
	return /** @type {LocalizedString} */ ("Vessel name and IMO number")
});